/**
 * BRINUTI — LAPOK-ELLENŐRZŐ, KOSÁR (2026-10-26, TESZT-téma)
 *
 *   1. Kosárpanel / kosároldal: a tétel alatti apró szürke sor („fekete
 *      szalag · BRINUTI - önismereti”) helyett egy sorba férő címkék; a
 *      lapok kiemelt („Lapok: Önismereti”). Az „Előnézet” gomb marad „Előnézet”.
 *   2. Kosár-előnézet (CartImageZoomModal): az „Ilyen lapok lesznek benne”
 *      sor kiemelt, fölötte a lapok valódi kétoldalas képe (nagyítóval); a
 *      „Vissza a kosárba” gomb felirata „Minden rendben – vissza a kosárba”.
 *
 * A kosár soraiból és a zoom-ablakból csak olvasunk, a meglévő kódot
 * (brinuti-cro.js, cart-products) nem módosítjuk; a kosár újrarenderelése
 * után a MutationObserver újra ráteszi a címkéket. Ha bármi nem ismerhető
 * fel, a sor érintetlen marad.
 */
(function () {
  'use strict';
  var B = window.BrinutiBeliv;
  if (!B) return;
  var esc = B.esc;
  var idozito = null;

  function tisztit(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }

  /* ---------- 1. Kosársorok ---------- */
  function kosarSorok() {
    var elemek = document.querySelectorAll('.brinuti-tetel-osszefoglalo');
    Array.prototype.forEach.call(elemek, function (el) {
      var most = tisztit(el.textContent);
      if (!most || el.getAttribute('data-bv-kesz') === most) return;

      var reszek = most.split(/\s*·\s*/).filter(Boolean);
      var belivResz = null;
      var b = null;
      /* A kosárszöveg: „fekete szalag · BRINUTI - önismereti” (csak az
         Önismeretinél van „BRINUTI -” előtag), de „fekete szalag ·
         pontrácsos”, „… · vonalas”, „… · üres” stb. is lehet. A szalag
         részt kihagyjuk, a maradékból az első felismert lapfajta a miénk. */
      reszek.forEach(function (r) {
        if (b || /szalag/i.test(r)) return;
        var f = B.felismer(r);
        if (f) { b = f; belivResz = r; }
      });
      if (!b) return;

      var html = '<span class="bv-sorchip bv-sorchip--hot">Lapok: ' + esc(b.nev) + '</span>';
      reszek.forEach(function (r) {
        if (r === belivResz) return;
        html += '<span class="bv-sorchip">' + esc(r) + '</span>';
      });
      el.classList.add('bv-kosar-chips');
      el.innerHTML = html;
      el.setAttribute('data-bv-kesz', tisztit(el.textContent));
    });
  }

  /* ---------- 2. Kosár-előnézet ---------- */
  function zoom() {
    var modal = document.getElementById('CartImageZoomModal');
    var adat = document.getElementById('ZoomAdat');
    if (!modal || !adat) return;

    var sorok = adat.querySelectorAll('.brinuti-zoom-adat__sor');
    var belivSor = null;
    Array.prototype.forEach.call(sorok, function (s) {
      if (!belivSor && /Ilyen lapok/i.test(s.textContent)) belivSor = s;
    });
    var kartya = modal.querySelector('.bv-zoom-kartya');
    if (!belivSor) {
      if (kartya) kartya.remove();
      return;
    }
    var bEl = belivSor.querySelector('b');
    var b = bEl ? B.felismer(bEl.textContent) : null;
    if (!b) return;

    if (!belivSor.classList.contains('bv-zoom-hot')) belivSor.classList.add('bv-zoom-hot');

    if (!kartya) {
      kartya = document.createElement('div');
      kartya.className = 'bv-zoom-kartya';
      adat.parentNode.insertBefore(kartya, adat);
    } else if (kartya.nextElementSibling !== adat) {
      adat.parentNode.insertBefore(kartya, adat);
    }
    /* Csak akkor építjük újra, ha másik lapfajta lett (a kép betöltődése
       nem számít változásnak). */
    if (kartya.getAttribute('data-bv-jel') !== b.k) {
      kartya.innerHTML = '<p class="bv-zoom-kartya__cim">Ellenőrizd a lapokat</p>' +
        B.kepHtml(b.k) +
        '<p class="bv-zoom-kartya__le"><b>' + esc(b.nev) + '</b> · ' + esc(b.le) + '</p>';
      kartya.setAttribute('data-bv-jel', b.k);
    }
    B.kepBetolt(kartya);

    Array.prototype.forEach.call(modal.querySelectorAll('button'), function (g) {
      if (tisztit(g.textContent) === 'Vissza a kosárba') g.textContent = 'Minden rendben – vissza a kosárba';
    });
  }

  function frissit() {
    kosarSorok();
    zoom();
  }
  function halasztott() {
    clearTimeout(idozito);
    idozito = setTimeout(frissit, 100);
  }

  function indul() {
    frissit();
    new MutationObserver(halasztott).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indul);
  else indul();
})();